package com.ervasstudio.tracoemovimento.pages.cursos.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.model.Aluno
import com.ervasstudio.tracoemovimento.model.Paginas
import com.ervasstudio.tracoemovimento.repository.BlogRepository.checkEmailAlunoExists
import com.ervasstudio.tracoemovimento.repository.BlogRepository.getAlunoByEmail
import com.ervasstudio.tracoemovimento.repository.BlogRepository.sendNewAluno
import com.ervasstudio.tracoemovimento.util.rememberIsMobile
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.browser.window
import kotlinx.coroutines.launch


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun LoginPage() {
    var thisemail by remember { mutableStateOf("") }
    var thisSenha by remember { mutableStateOf("") }
    val isMobile = rememberIsMobile()

    val ctx = rememberPageContext()
    val coroutineScope = rememberCoroutineScope()
    var apiErrorMessage by remember { mutableStateOf<String?>(null) }
    var errorMessage by remember { mutableStateOf<String?>(null) }
    val auth = Firebase.auth
    var emailError by remember { mutableStateOf<String?>(null) }
    var senhaError by remember { mutableStateOf<String?>(null) }
    var isLoging by remember { mutableStateOf(false) }
    val localStorageKey = "aluno"
    val localStorageKeyNome = "nomeAluno"

    Login(
        email = thisemail,
        onEmailChange = { thisemail = it },
        senha = thisSenha,
        onSenhaChange = { thisSenha = it },
        naoTenhoContaClick = { ctx.router.navigateTo(Paginas.SIGNUP.rota) },
        onEntrarClick = {
            coroutineScope.launch {
                try {

                    val aluno = getAlunoByEmail(thisemail)

                    if (aluno != null) {

                        try {
                            val result = auth.signInWithEmailAndPassword(thisemail, thisSenha)
                            println("Usuário logado: ${result.user?.uid}")
                            if (result.user?.email !== null) {
                                result.user?.email?.let { window.localStorage.setItem(localStorageKey, it) }
                                window.localStorage.setItem(localStorageKeyNome, aluno.nome!!)
                                ctx.router.navigateTo(Paginas.`MEUS CURSOS`.rota)

                            }
                        }catch (e: Exception) {
                            senhaError = e.message
                            isLoging = false
                        }

                    } else {
                        emailError = "Usuario nao existe"
                        isLoging = false
                    }

                } catch (e: Exception) {

                }
            }
        },
        externalError = "",
        errorMessage = errorMessage,
        emailError = emailError,
        senhaError = senhaError,
        emailErrorChange = { emailError = it },
        senhaErrorChange = { senhaError = it },
        isLoging = isLoging,
        isLogingChange = {isLoging = it },
        isMobile = isMobile,
        onGoogleLoginButtonClick = {
            coroutineScope.launch {
                try {
                    val aluno = getAlunoByEmail(it.email!!)

                    if (aluno != null) {
                        it.email.let { window.localStorage.setItem(localStorageKey, it) }
                        it.displayName?.let { value -> window.localStorage.setItem(localStorageKeyNome, value) }
                        ctx.router.navigateTo(Paginas.`MEUS CURSOS`.rota)
                    }else{
                        val partesNome = it.displayName?.trim()?.split("\\s+".toRegex(), limit = 2)
                        val primeiroNome = partesNome?.getOrNull(0) ?: ""
                        val sobrenome = partesNome?.getOrNull(1) ?: ""
                        ctx.router.navigateTo(Paginas.`MEUS CURSOS`.rota)


                        val novoAluno = Aluno(
                            nome = primeiroNome,
                            sobrenome = sobrenome,
                            email = it.email,
                            celular = "0",
                            sexo = "",
                            nascimento = "",
                            id_autor = "",
                            dataCriacao = "",
                            dataModificacao = "",
                            slug = "",
                            id = "",
                            status = "",
                        )
                        val alunoGravadoJetengine = sendNewAluno(aluno = novoAluno)
                        if (alunoGravadoJetengine) {
                            it.email.let { window.localStorage.setItem(localStorageKey, it) }
                            it.displayName?.let { value -> window.localStorage.setItem(localStorageKeyNome, value) }
                            ctx.router.navigateTo(Paginas.`MEUS CURSOS`.rota)
                        }
                    }
                }catch (e: Exception) {

                }
            }
        }
    )

}